import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { catchError, Observable, throwError } from "rxjs";
import { TransportModal } from "../../models/transport-modal.model";

@Injectable({
	providedIn: 'root'
})
export class CustomerService {

	uriCustomer: string = '/api/v1/customer';
	endpoint: string = environment.backend_url;

	constructor(private http: HttpClient) {
		this.http = http;
	}

	getModalByCountry(country: string, language: string): Observable<TransportModal[]> {
		const subRoute = `/modais/${country}/${language}`;
		return this.http.get<TransportModal[]>(this.endpoint + this.uriCustomer + subRoute)
			.pipe(
				catchError((error: HttpErrorResponse) => {
					return throwError(() => error.status)
				})
			);
	}
}
